import { HttpRequestData, httpUtil } from '@esg/framework';
import { getEnv } from '@esg/shared';

interface GetOverviewOrganizationRequest extends HttpRequestData {
    readonly startTime: string;
    readonly endTime: string;
}

export interface GetOverviewOrganizationResponseItem {
    currentOrganizationCount: number;
    pastOrganizationCount: number;
}

export const getOverviewOrganization = httpUtil.createHttpRequestMeta<
    GetOverviewOrganizationRequest,
    GetOverviewOrganizationResponseItem
>({
    baseUrl: () => getEnv().AGENCY_SERVER,
    path: '/api/v1/organizations/overview',
    method: 'GET',
    authentication: 'bearer',
});